import React from 'react';
import { Star } from 'lucide-react';
import { mockTestimonials } from '../data/mockData';

const WhyPeopleLoveIt = () => {
  const testimonials = mockTestimonials.slice(0, 3);

  return (
    <div className="py-24 px-4 bg-gradient-to-br from-purple-50/60 to-pink-50/60" data-testid="testimonials-section">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-3xl sm:text-4xl font-bold text-center text-gray-800 mb-3">
          Why People Love It
        </h2>
        <p className="text-center text-gray-500 mb-14 text-base">
          Join thousands who have preserved their stories
        </p>

        <div className="grid md:grid-cols-3 gap-6 stagger-children">
          {testimonials.map((t, index) => (
            <div key={index} className="testimonial-card card-hover fade-in" data-testid={`testimonial-${index}`}>
              <div className="flex gap-1 mb-4">
                {Array.from({ length: 5 }).map((_, i) => (
                  <Star key={i} className="w-4 h-4 text-amber-400 fill-amber-400" />
                ))}
              </div>
              <p className="text-sm text-gray-700 leading-relaxed mb-5 italic">
                "{t.text}"
              </p>
              <div className="flex items-center gap-3 pt-4 border-t border-gray-100">
                <div className="w-10 h-10 bg-gradient-to-br from-pink-200 to-purple-200 rounded-full flex items-center justify-center text-sm font-bold text-purple-600">
                  {t.name.charAt(0)}
                </div>
                <div>
                  <p className="font-semibold text-sm text-gray-800">{t.name}</p>
                  <p className="text-xs text-gray-500">{t.role || 'Life Echo User'}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default WhyPeopleLoveIt;
